import { ActionReducer, createReducer, on } from '@ngrx/store';
import { AuthActions } from '../actions';
import { User } from '@auth0/auth0-spa-js';

export const authStatusFeatureKey: string = 'authStatus';

export interface State {
  user: User | null;
  isAuthenticated: boolean;
  token: string;
  isLoginInProcess: boolean;
}

export const initialState: State = {
  user: null,
  isAuthenticated: false,
  token: '',
  isLoginInProcess: true,
};

export const reducer: ActionReducer<State> = createReducer(
  initialState,
  on(AuthActions.loadUserSuccess, (state, { user }) => {
    return {
      ...state,
      user,
    };
  }),
  on(
    AuthActions.checkAuthSuccess,
    AuthActions.setAuthenticated,
    (state, { isAuthenticated }) => {
      return {
        ...state,
        isAuthenticated,
      };
    }
  ),
  on(
    AuthActions.loadAccessTokenSuccess,
    (state, { token }) => {
      return {
        ...state,
        token,
      };
    }
  ),
  on(
    AuthActions.setIsLoginInProcess,
    (state, { isLoginInProcess }) => {
      return {
        ...state,
        isLoginInProcess,
      };
    }
  )
);

export const selectUser: (state: State) => User | null = (state: State) => state.user;
export const selectIsAuthenticated: (state: State) => boolean = (state: State) => state.isAuthenticated;
export const selectAccessToken: (state: State) => string = (state: State) => state.token;
export const selectIsLoginInProcess: (state: State) => boolean = (state: State) => state.isLoginInProcess;
